class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) {
      this.setSummaryAccessibility(cartDrawerNote);
    }

    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');

        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    // 🔥 INICIAR / REINICIAR CONTADOR AL ABRIR
    window.__cartTimerStart = Date.now();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute(
        'aria-expanded',
        !event.currentTarget.closest('details').hasAttribute('open')
      );
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    const inner = this.querySelector('.drawer__inner');
    if (inner.classList.contains('is-empty')) {
      inner.classList.remove('is-empty');
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();

      // 🔥 REINICIAR CONTADOR TRAS RENDER AJAX
      window.__cartTimerStart = Date.now();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
/* =========================================================
   DESCUENTO PROGRESIVO - CARRITO
   ========================================================= */

(function () {

  let discountUpdateTimer;

  async function updateQuantityDiscount() {

    const box = document.querySelector('#cart-quantity-discount');

    if (!box) return;

    try {

      const response = await fetch('/cart.js', {
        headers: {
          'Accept': 'application/json'
        },
        credentials: 'same-origin'
      });

      const cart = await response.json();

      const quantity = cart.item_count;

      const count = box.querySelector('.cqd-count');
      const message = box.querySelector('.cqd-message');
      const progress = box.querySelector('.cqd-progress-fill');

      if (!count || !message || !progress) return;


      /* 1 PRENDA */

      if (quantity === 1) {

        count.textContent = '1 prenda';

        progress.style.width = '20%';

        message.innerHTML =
          'Añade 1 prenda más y consigue un <strong>10% de descuento</strong>';

      }


      /* 2 PRENDAS */

      else if (quantity === 2) {

        count.textContent = '2 prendas';

        progress.style.width = '40%';

        message.innerHTML =
          '<span class="cqd-success">✓ 10% conseguido</span> · ' +
          'Añade 1 prenda y consigue <strong>15%</strong>';

      }


      /* 3 PRENDAS */

      else if (quantity === 3) {

        count.textContent = '3 prendas';

        progress.style.width = '60%';

        message.innerHTML =
          '<span class="cqd-success">✓ 15% conseguido</span> · ' +
          'Añade 1 prenda y consigue <strong>20%</strong>';

      }


      /* 4 PRENDAS */

      else if (quantity === 4) {

        count.textContent = '4 prendas';

        progress.style.width = '80%';

        message.innerHTML =
          '<span class="cqd-success">✓ 20% conseguido</span> · ' +
          'Añade 1 prenda y consigue <strong>25%</strong>';

      }


      /* 5 O MÁS */

      else if (quantity >= 5) {

        count.textContent = quantity + ' prendas';

        progress.style.width = '100%';

        message.innerHTML =
          '<span class="cqd-success">✓ ¡25% de descuento conseguido!</span> · ' +
          'Máximo ahorro';

      }


      /* CARRITO VACÍO */

      else {

        count.textContent = '0 prendas';

        progress.style.width = '0%';

        message.innerHTML =
          'Añade 2 prendas y consigue un <strong>10% de descuento</strong>';

      }

    } catch (error) {

      console.warn(
        'Error actualizando descuento por cantidad:',
        error
      );

    }
  }


  /* ---------------------------------------------------------
     ACTUALIZACIÓN
     --------------------------------------------------------- */

  function scheduleDiscountUpdate() {

    clearTimeout(discountUpdateTimer);

    discountUpdateTimer = setTimeout(
      updateQuantityDiscount,
      350
    );

  }


  /* ---------------------------------------------------------
     AL CARGAR
     --------------------------------------------------------- */

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      updateQuantityDiscount
    );

  } else {

    updateQuantityDiscount();

  }


  /* ---------------------------------------------------------
     DETECTAR CAMBIOS EN EL CARRITO
     --------------------------------------------------------- */

  const observer = new MutationObserver(function (mutations) {

    let changed = false;

    mutations.forEach(function (mutation) {

      if (
        mutation.target.closest &&
        mutation.target.closest('#cart-quantity-discount')
      ) {
        return;
      }

      changed = true;

    });

    if (changed) {
      scheduleDiscountUpdate();
    }

  });


  function startObserver() {

    const drawer = document.querySelector('cart-drawer');

    if (!drawer) return;

    observer.observe(drawer, {
      childList: true,
      subtree: true
    });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      startObserver
    );

  } else {

    startObserver();

  }


})();